import {
  Box,
  CardContent,
  Typography,
  Grid,
  Paper,
  Card,
  Stack,
  Tooltip,
} from "@mui/material";
import { CheckCircle, Warning } from "@mui/icons-material";
import InsightsIcon from "@mui/icons-material/Insights";
import InfoIcon from "@mui/icons-material/Info";
import { palette, theme  as colorTheme} from "../../../../Convoze.theme";



const CustomerMetrics = ({ customerAnalytics }) => {
  const metrics = [
    {
      title: "CSAT",
      score: customerAnalytics?.AnalyzeCustomerMetrics?.CsatScore || "50%",
      description:
        customerAnalytics?.AnalyzeCustomerMetrics?.CsatDescription ||
        "The customer did not express clear satisfaction or dissatisfaction, indicating a neutral experience.",
    },
    {
      title: "CES",
      score: customerAnalytics?.AnalyzeCustomerMetrics?.CesScore || "40%",
      description:
        customerAnalytics?.AnalyzeCustomerMetrics?.CesDescription ||
        "The customer faced difficulties in accessing data, indicating a complex interaction.",
    },
    {
      title: "TSS",
      score: customerAnalytics?.AnalyzeCustomerMetrics?.TssScore || "45%",
      description:
        customerAnalytics?.AnalyzeCustomerMetrics?.TssDescription ||
        "The transaction was not completed successfully, leading to a lower satisfaction score.",
    },
  ];
  return (
    <Paper
      elevation={1}
      sx={{
        flex: 1,
        p: 2,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
      }}
    >
      <Stack direction={"column"} spacing={2}>
        <Typography
          variant="body1"
          fontWeight={500}
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <InsightsIcon />
          Customer Metrics
          <Tooltip
            title="Gives the KPI's based on customer feedback"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <InfoIcon
              sx={{
                fontSize: 18,
                color: "grey",
              }}
            />
          </Tooltip>
        </Typography>
        {/* <Typography variant="body1" mb={1} color="#878787">
          Compliance-Sensitive Words
        </Typography> */}
      </Stack>

      <Grid container spacing={2}>
        {metrics.map((item, index) => (
          <>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <Card
                sx={{
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 2,
                  border: "1px solid #f7f8f9",
                  height: 80,
                  borderRadius: 3,
                  flex: 1,
                }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ justifyContent: "space-between", width: "100%" }}
                >
                  <Typography fontWeight="bold" color={colorTheme('palette', 'primary').value}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Score: <span style={{ fontWeight: 600 }}>{item.score}</span>
                  </Typography>
                </Stack>
                <Typography variant="body2">{item.description}</Typography>
              </Card>
            </Grid>
          </>
        ))}
      </Grid>
    </Paper>
  );
};

export default CustomerMetrics;
